
import { ArbetsorderAttributEventMessage } from "./ArbetsorderAttributEventMessage";
export class DestineringAttributEventMessage extends ArbetsorderAttributEventMessage {
    destineringId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DestineringAttributEventMessage";
    constructor() {
        super(DestineringAttributEventMessage.$type);
    }
}

export enum DestineringAttributGrupper {
    VirkesorderValidation = "Virkesorder.Validation",
    Viol3Validation = "Viol3.Validation",
    Transport = "Transport"
}

export enum DestineringAttributVirkesorderValidationNycklar {
    GenericMessages = "GenericMessages"

}

export enum DestineringAttributViol3ValidationNycklar {
    ValidationAlerts = "ValidationAlerts"
}
